export
const name: string = "Skybox";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec3  a_position;
    attribute vec2  a_tex_coord;
    attribute float a_visibility;
    attribute float a_manipulation;

    uniform mat4    u_view_projection;
    uniform mat4    u_manipulator;
`;

export
const varyings: string = `
    varying vec2    v_tex_coord;
    varying float   v_selected;
`;

export
const implementation: string = `
    void main()
    {
        vec4 position = vec4(a_position, 1.0);
    #ifdef MANIPULATOR_ENABLED
        if (a_manipulation > 0.5) {
            position = u_manipulator * position;
        }
    #endif
        // As we have the a_visibility attribute in vertex shader always defined and used in the application,
        // we have to use that atribute otherwise the shader will not work no matter the bounding box is
        // turned on/off by adding/removing the geometry to render graph.
        position = position * a_visibility;

        gl_Position = (u_view_projection * position).xyww;

        v_tex_coord = a_tex_coord;
        v_selected  = 0.0; // not used it is here only just because the applytexturToSurface expect the variable to be defined and here it is almost none performance hit
    }
`;
